import React from "react";
import "./ArcStageScoreBreakdown.css";

function seconds(value) {
  return typeof value === "number" && Number.isFinite(value) ? `${value.toFixed(2)} s` : "-";
}

function count(value) {
  return Number.isInteger(value) && value >= 0 ? value : "-";
}

export default function ArcStageScoreBreakdown({ scoreDetail, timerDetails }) {
  const penalties = scoreDetail.penaltyBreakdown;
  const rows = [
    ["Scored base time", penalties.baseTimeSeconds],
    ["Target penalties", penalties.targetPenaltySeconds],
    ["No-shoot penalties", penalties.noShootPenaltySeconds, scoreDetail.noShootPenaltyCount],
    ["Procedural penalties", penalties.proceduralPenaltySeconds, scoreDetail.proceduralPenaltyCount],
    ["Major penalties", penalties.majorPenaltySeconds, scoreDetail.majorPenaltyCount],
    ["Additional time penalty", penalties.additionalPenaltySeconds],
    ["Total penalties", penalties.totalPenaltySeconds, undefined, "subtotal"],
    ["Final stage score", scoreDetail.stageScore, undefined, "total"],
  ];
  const targets = Array.isArray(scoreDetail.targetEntries) ? scoreDetail.targetEntries.filter(Boolean) : [];
  const hasRawTime = typeof scoreDetail.recordedStageTimeSeconds === "number";

  return (
    <div className="arc-score-breakdown">
      <div className="arc-score-breakdown-context">
        <span>{hasRawTime ? "RO-entered time" : "Limited (base 0 s)"}</span>
        {hasRawTime && <span>Recorded time <strong>{seconds(scoreDetail.recordedStageTimeSeconds)}</strong></span>}
        <span>Late shots <strong>{count(scoreDetail.lateShotCount)}</strong></span>
      </div>
      <dl className="arc-score-calculation" aria-label="Saved score calculation">
        {rows.map(([label, value, occurrences, emphasis]) => (
          <div key={label} className={emphasis ? `arc-score-calculation-${emphasis}` : undefined}>
            <dt>{label}{typeof occurrences === "number" && <span className="arc-score-penalty-count" aria-label={`${occurrences} occurrences`}>{count(occurrences)}</span>}</dt>
            <dd>{seconds(value)}</dd>
          </div>
        ))}
      </dl>
      <section className="arc-score-targets" aria-labelledby="arc-score-targets-heading">
        <h3 id="arc-score-targets-heading">Target Breakdown</h3>
        {targets.length === 0 ? <p>No target detail was uploaded.</p> : (
          <div className="arc-score-target-table-wrap">
            <table className="arc-score-target-table">
              <thead><tr><th scope="col">Target</th><th scope="col">Recorded hits</th><th scope="col">Misses</th><th scope="col">Failure to engage</th></tr></thead>
              <tbody>{targets.map((target, index) => {
                const steel = target.targetType === "Steel" || target.inputKind === "Hit Count (Steel)";
                const zones = target.inputKind === "Paper Zones (A/C/D)" ? ["A", "C", "D"] : ["A", "B", "C", "D"];
                return (
                  <tr key={`${target.targetSlotKey}-${index}`}>
                    <th scope="row">{target.targetSlotKey || `Target ${index + 1}`}<small>{target.targetType || target.inputKind}</small></th>
                    <td>
                      {steel ? `${count(target.steelHits)} hits` : <span className="arc-score-zone-values">{zones.map(zone => <span key={zone}>{zone} <strong>{count(target[`zone${zone}`])}</strong></span>)}</span>}
                      {target.excessHitPolicyOverride && <small>Excess hits: {target.excessHitPolicyOverride}</small>}
                    </td>
                    <td>{count(target.manualMisses)}</td>
                    <td>{count(target.failureToEngageCount)}</td>
                  </tr>
                );
              })}</tbody>
            </table>
          </div>
        )}
      </section>
      {timerDetails && <details className="arc-score-timer-detail"><summary>Recorded Timer String</summary>{timerDetails}</details>}
    </div>
  );
}
